import { ElementRef, EventEmitter, Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { IAbstractPresenter, IconName, ILanguageObject } from '@core/interfaces';
import { ISwitchComponent, ISwitchPresenter } from './interfaces';

@Injectable({ providedIn: 'root' })
export class SwitchPresenter extends IAbstractPresenter<ISwitchComponent> implements ISwitchPresenter {
	loading$: Observable<boolean> = of(false);
	translations: ILanguageObject = {};
	checked: boolean = false;
	switchLabel: boolean = false;

	onLabel: string | null = null;
	offLabel: string | null = null;
	onIcon?: IconName = 'check';
	offIcon?: IconName = 'x';
	disabled: boolean = false;
	dinamicIcon?: IconName;
	changed: EventEmitter<void> = new EventEmitter<void>();

	switchCustom!: ElementRef<HTMLButtonElement>;

	constructor() {
		super();
	}

	override onInit(): void {
		this.dinamicallySetIcon();
		this.setSwitchLabel();
	}

	dispatchActions(): void {}

	suscribeObservers(): void {}

	onClick(): void {
		if (this.view.disabled) return;
		
		this.toggleChecked();
		this.view.changed.emit();
	}

	private toggleChecked(): void {
		this.view.checked = !this.view.checked;
		this.dinamicallySetIcon();
	}

	private dinamicallySetIcon(): void {
		if (this.view.checked) {
			this.view.dinamicIcon = this.view.onIcon;
		} else {
			this.view.dinamicIcon = this.view.offIcon;
		}
	}

	private setSwitchLabel(): void {
		this.view.switchLabel = !!this.view.onLabel || !!this.view.offLabel;
	}

	getCheckedLabel(value: boolean): boolean {
		return this.view.checked === value;
	}
}
